import { useEffect, useState } from "react";
import api from "./../../BrandOnBoarding/api";

const FALLBACK_IMAGE_URL =
  "https://tse1.mm.bing.net/th?id=OIP.WK5-vaL-Km-aumD0JGCp1QHaHa&w=474&h=474&c=7";

export default function useBingImage(entity, category) {
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState("");

  async function generateImage() {
    const searchTerm = `${category}: ${entity}`;
    try {
      setLoading(true);
      let response = await api.get(`/product-images?searchTerm=${searchTerm}`);
      response = response.data;
      if (Array.isArray(response) && response.length > 0) {
        setImage(response[0]['link']);
      } else {
        setImage(FALLBACK_IMAGE_URL);
      }
    } catch (error) {
      console.log(`Error: generating image ${error.message}`);
      setImage(FALLBACK_IMAGE_URL);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!entity) return;
    generateImage();
  }, [entity, category]);

  return { loading, image };
}
